import { DrawerContext } from '../context/DrawerContext';
import React from 'react';

export const useDrawer = () => React.useContext(DrawerContext);
